import { Mail, Globe, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-[#0A2540] border-t border-white/10 mt-auto">
      <div className="container mx-auto px-6 py-6 md:py-8">
        
        {/* Main Grid - 2 columns on desktop, stacked on mobile */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          
          {/* Bloc 1: Identité */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold text-white mb-1 tracking-tight">
              QuiQuoiOùQuand
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed max-w-xs mx-auto md:mx-0">
              La nouvelle génération de mise en relation.
            </p>
          </div>

          {/* Bloc 2: Contact */}
          <div className="text-center md:text-left">
            <h4 className="text-xs font-semibold text-[#F57C00] uppercase tracking-wider mb-2">
              Contact
            </h4>
            <div className="flex flex-col space-y-1.5">
              <a 
                href="mailto:contact@quiquoiouquand.com"
                className="inline-flex items-center justify-center md:justify-start gap-2 text-gray-300 hover:text-white text-sm transition-colors duration-200"
              >
                <Mail className="h-3.5 w-3.5 text-[#F57C00]" />
                contact@quiquoiouquand.com
              </a>
              <a 
                href="https://quiquoiouquand.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center md:justify-start gap-2 text-gray-300 hover:text-white text-sm transition-colors duration-200"
              >
                <Globe className="h-3.5 w-3.5 text-[#F57C00]" />
                quiquoiouquand.com
              </a>
              <Link 
                to="/contact"
                className="inline-flex items-center justify-center md:justify-start gap-2 text-gray-300 hover:text-white text-sm transition-colors duration-200"
              >
                <MessageSquare className="h-3.5 w-3.5 text-[#F57C00]" />
                Nous contacter
              </Link>
            </div>
          </div>
        </div>

        {/* Ligne de séparation */}
        <div className="border-t border-white/10 mt-6 pt-4">
          <p className="text-center text-xs text-gray-400">
            © 2026 QQOQ, Conçu par Franck EZRATTI, Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}
